import { render, staticRenderFns } from "./veJkyFundClaimShow.vue?vue&type=template&id=4ffc7388&scoped=true"
import script from "./veJkyFundClaimShow.vue?vue&type=script&lang=js"
export * from "./veJkyFundClaimShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc7388",
  null
  
)

export default component.exports